import React from 'react';
import { useLearningPathsStore } from '../../../LearningPaths.store';
import AddContentBtn from '../AddContentBtn';
import { useGetFF } from '@fstack-tech/ff_react_module';
import FocusDottedBtn from 'shared_ui_components/DottedBtn/FocusDottedBtn';
import { usePathValidations } from '../../../LearningPaths.utils';

const AddTrainingModulesBtn = () => {
  const { openTrainingModulesModal } = useLearningPathsStore();
  const { isEnabled: ff_learningPaths } = useGetFF({ flag_id: 'learning_paths' });
  const { learningPath } = useLearningPathsStore();
  const { isPathOwner } = usePathValidations({ learningPath });

  return (
    <>
      {ff_learningPaths ? (
        <FocusDottedBtn
          onClick={openTrainingModulesModal}
          showPlusSign
          label={'Add Skill Sets'}
          learningPath={learningPath}
          isPathOwner={isPathOwner}
        />
      ) : (
        <AddContentBtn label="Add modules" onClick={openTrainingModulesModal} />
      )}
    </>
  );
};

export default AddTrainingModulesBtn;
